import type { Data } from '@typings/productGrid';

const EMPTY_DATA: Data = { hits: [], nbHits: 0, nbPages: 0, page: 0 };

interface FetchAmbassadorsParams {
  locale: string;
  page?: number;
}

export const fetchAmbassadorsClient = async ({
  locale,
  page = 0,
}: FetchAmbassadorsParams): Promise<Data> => {
  const params = new URLSearchParams({
    filters: JSON.stringify({ authorType: 'Ambassador' }),
    page: page.toString(),
    pageSize: '10',
    lang: locale,
  });
  const res = await fetch(`/api/authors/searchAuthors?${params}`);
  if (!res.ok) return EMPTY_DATA;
  const data = await res.json();
  return data ? { ...data, page: 0 } : EMPTY_DATA;
};

interface FetchStoriesParams {
  locale: string;
  page?: number;
  sort?: string;
  category?: string | null;
}

export const fetchStoriesClient = async ({
  locale,
  page = 0,
  sort,
  category,
}: FetchStoriesParams): Promise<Data> => {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: '10',
    lang: locale,
  });
  if (category) params.set('filters', JSON.stringify({ categories: category }));
  if (sort) params.set('sort', sort);
  const res = await fetch(`/api/stories/searchStories?${params}`);
  if (!res.ok) return EMPTY_DATA;
  const data = await res.json();
  return data ? { ...data, page: 0 } : EMPTY_DATA;
};

export const parseSortOption = (sortValue?: string): string | undefined => {
  if (!sortValue) return undefined;
  const [field, direction] = sortValue.split(',');
  return JSON.stringify({ field, direction });
};
